import React, { useState, useEffect } from 'react';
import { DataView } from 'primereact/dataview';
import 'primeicons/primeicons.css';
import Footer from './Footer';
import { Divider } from 'primereact/divider';
import { Carousel } from 'primereact/carousel';
import CSCarousel from './components/CSCarousel';
import classNames from 'classnames';

export default function Dataview() {

  var mSolutionsData = [

    {
      id: '1000',
      code: '"CS Agronex": From Lab to Field your Agrochemical Partner',
      name: 'Agrochemicals',
      // points: 'HR Management | Procurement Management | Sales & Dispatch | Goods Receipt  | Inventory Management | Production | Finance  ',
      image: './website/agro.png',
      // description: 'Connecting all departments in a seamless manner, providing integrated data view.',
      // point1: 'CS- Agronex: From Lab to Field your Agrochemical Partner',
      point2: 'Elevate your business with "CS Agronex" exclusively tailored for Agrochemical industry.',
      point3: 'Seamlessly integrate operations, gain real time insights, incorporate advanced costing and analytics and achieve precision. Optimize costs, ensure compliance and make informed decisions.',
      point4: ' ',
      point5: 'Ready to transform your business ?',
      point6: 'Contact us for a personalized demonstration and propel your company towards sustainable growth.',
      details: 'More details',
      url: 'https://agronex.chinmmaisystems.com'

    },
    {
      id: '1001',
      code: '"CS BuildNex Core": Redefining Foundations, Redefining Future',
      name: 'Real Estate',
      // points: 'HR Management | Project Management | Material Management | Marketing & Sales | Finance ',
      image: './website/real-estate-2.png',
      // description: 'Automation across all functional areas in construction industry',
      // point1: 'CS BuildNex Core: Redefining Foundations, Redefining Future',
      point2: 'Our Realty Software offers a transformative approach to your construction projects that streamline project initiation, enhance financial transparency, optimize procurement, seamlessly integrate lead management, sales, finance, and construction modules and achieve substantial cost savings. Our end to end construction management ensures efficient scheduling, resource allocation, and collaboration, positioning your company for success.',
      point5: 'Ready to revolutionize your projects and maximize your bottom line ?',
      point6: 'Contact us for a personalized demonstration and experience the cost saving value proposition.',
      details: 'More details',
      // url: 'https://venoble.chinmmaisystems.com'

    },

    {
      id: '1003',
      code: '"CS UnityPlex": From Production to Delivery Connect Every Dot.',
      name: 'Manufacturing ',
      // points: 'HR Management | Job Order Management | Dispatch Management | Packaging using Mobile App  |  Labels Design & Generation(QR Code based) ',
      image: './website/industry.png',
      // description: 'Tracking of all deliverables from Order to Dispatch',
      // point1: 'CS UnityPlex: From Production to Delivery UnityPlex Connects Every Dot.',
      point2: 'Experience the all encompassing efficiency of "CS UnityPlex", where production, packaging, dispatch, and procurement seamlessly converge. Our platform integrates personalized production planning, on the go packing, efficient dispatch and procurement management, all accessible through dedicated mobile apps. Stay connected at every stage, empowering your teams to adapt on the fly and ensuring a unified approach to tasks. Elevate customer satisfaction with real time order updates and transparent communication.',
      point6: 'Choose "CS UnityPlex" for a holistic, mobile driven solution that brings excellence to every facet of your operations.',
      details: 'More details',
      // url: 'https://agronex.chinmmaisystems.com',
    },
    {
      id: '1004',
      code: '"CS RetailPro Connect": Shopping Simplified, Results Amplified',
      name: 'Retail Stores',
      // points: 'HR Management | Kits Packaging & Dispatch | Kit Sales | Finance | Procurement Management | Inventory Management | Goods Receipt ',
      image: './website/retail-new.png',
      // description: 'Enabling seamless end to end data flow from Purchase Indent to Invoice generation',
      // point1: 'CS RetailPro Connect: Shopping Simplified, Results Amplified',
      point2: 'Welcome to "CS RetailPro Connect", where retail management meets seamless efficiency. Our software combines an intuitive Point of Sale system, advanced inventory management, customer centric CRM, smart sales analytics and an efficient procurement and finance modules. Unleash the power of unified multi channel integration, enabling you to streamline operations and drive growth.',
      point3: 'Whether you are a boutique or a large retail chain, RetailPro Connect is your key to efficient and successful retail management.',
      point6: 'Contact us for a personalized demonstration and embark on a journey of retail excellence.',
      details: 'More details',
      // url: 'https://99v.chinmmaisystems.com',
    },
    {
      id: '1005',
      code: '"CS Vidyodaya": Shaping Futures, Streamlining Operations',
      name: 'Education',
      // points: 'Admissions | Student Administration | Finance | SecureTrak | Academics | HR Management | Logins',
      image: './website/College.png',
      // description: 'Integrated process solution involving Academician, Student, Parent, Admin.',
      // point1: '"CS Vidyodaya": Shaping Futures, Streamlining Operations',
      point2: 'Experience the seamless scalability of "CS - Vidyodaya" institute management system. ',
      point3: 'Our solution not only manages every aspect of your institution but also facilitates effortless expansion to multiple branches. From admissions to alumni relations, finance, online classrooms, and student transport, our system ensures efficiency and growth across your educational network by streamlining operations, enhancing financial transparency, and ensuring efficient learning environment.',
      point5: 'Discover the transformative power of CS Vidyodaya ?',
      point6: 'Contact us for a personalized demonstration and witness the ease of scaling your institution.',
      details: 'More details',
      url: 'https://ezuse.chinmmaisystems.com'
    },
  ];

  const BannerImages = [
    {
      id: '1000',
      image: './hrm_banner.png',
      text: 'Welcome to HRM!'
    },
    {
      id: '1001',
      image: './agronex_banner.png',
      text: 'Explore Agronex Solutions'
    },
    {
      id: '1003',
      image: './vidyodaya_banner.png',
      text: 'Discover Vidyodaya'
    },
  ];

  const responsiveOptions = [
    {
      breakpoint: '1199px',
      numVisible: 1,
      numScroll: 6,
    },
    {
      breakpoint: '991px',
      numVisible: 2,
      numScroll: 6,
    },
    {
      breakpoint: '767px',
      numVisible: 1,
      numScroll: 6,
    },
  ];
  useEffect(() => {

  }, [BannerImages]);

  const itemTemplate = (item) => {
    return <img src={item.image} alt={item.description} style={{ width: '100%', display: 'block' }} />;
  };

  const CSSolutions = (product) => {

    return (
      <div className='border-bottom-2 border-primary-light lg:flex flex-wrap align-items-center'>
        <div className='col-12 md:col-8 lg:col-7 py-4'>
          <div className="text-primary text-2xl font-semibold mb-2 pl-4 font-normal">{product.name}</div>
          <div className="font-normal text-sm mb-2 font-semibold pl-4">{product.code}</div>
          <div className="font-normal text-sm pl-4 mb-2">{product.point1}</div>
          <div className="font-normal text-sm pl-4 ">{product.point2}</div>
          <div className="font-normal text-sm pl-4 ">{product.point3}</div>
          <div className="font-normal text-sm pl-4">{product.point4}</div>
          <div className="font-normal text-sm pl-4  pt-3 ">{product.point5}</div>
          <div className="font-normal text-sm pl-4 mb-2">{product.point6}</div>
          <a href={product.url} target="_blank" class="inline-flex align-items-right text-sm bg-primary text-primary border-round-lg ml-4 px-2 py-1 mr-8 mt-4">More details</a>
        </div>
        <div className="col-12 md:col-4 lg:col-5 ">
          <img src={product.image} className='product-image float-right w-full cbimg' alt={product.name} />
        </div>
      </div>
    );
  };

  // Out of the box solutions
  return (
    <div
    className={classNames('col-12 p-0 m-0', {
      'fullHeight': window.innerWidth >= 640, 
      'fullHeightmb': window.innerWidth < 640, 
    })}
  >
      {/* <img src="/Dataview_Banner1.png" alt="Solutions" className="col-12 p-0 m-0 md:w-full border-bottom-2 border-primary-light sm:flex flex-wrap justify-content-center cbimg" /> */}
      {/* <div className=" hidden lg:block">
                    <Carousel
                      value={BannerImages}
                      numVisible={1}
                      numScroll={1}
                      responsiveOptions={responsiveOptions}
                      className="custom-carousel w-full border-b-4 border-primary-light "
                      circular
                      autoplayInterval={3000}
                      itemTemplate={itemTemplate}
                      showNavigators={false}
                      showIndicators={false}
                    />
                  </div> */}
      <CSCarousel slides={BannerImages} />
      <div className='pb-8'>
        <DataView value={mSolutionsData} itemTemplate={CSSolutions} />
        <div className='flex flex-wrap'>
          <div className='col-12 md:col-8 lg:col-7 cfs'>
            <div className="text-800 text-lg font-semibold mb-2 pl-4 font-normal"> Cross Functional Solutions</div>
            <ul className='pl-2'>
              {/* <li className='p-2'><a href='https://www.chinmmaisystems.com' target='_blank'>Fixed Assets Management</a></li> */}
              <li className='p-2 font-semibold text-800 text-sm ml-6 '><a href='#' >Asset Management</a></li>
              <li className='p-2 font-semibold text-800 text-sm ml-6 '><a href='#' >Service Collaboration</a></li>
              <li className='p-2 font-semibold text-800 text-sm ml-6 '><a href='#' >Lead Management System</a></li>
              <li className='p-2 font-semibold text-800 text-sm ml-6 '><a href='https://nexahrm.chinmmaisystems.com' target='_blank'>HR Management</a></li>
            </ul>
          </div>
          <div className="col-12 md:col-4 lg:col-5">
            <img src='./website/Retail.png' className='product-image float-right w-full cbimg' alt='Retail' />
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  )
}